// extracted by mini-css-extract-plugin
module.exports = {"BlogGrid":"styles_BlogGrid___nuRj","item":"styles_item__fn29v"};